import { AxiosInstance } from 'axios';

import { EvictorAPIApiFactory } from '@cast/openapi-workload-eviction';

import { AXIOS_CONFIGURATION } from '../constants';

export const WorkloadEvictionApiAdapter = (client: AxiosInstance) => {
  const evictorApi = EvictorAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  return {
    getConfig: evictorApi.evictorAPIGetConfig,
    updateConfig: evictorApi.evictorAPIUpdateConfig,
    getAdvancedConfig: evictorApi.evictorAPIGetEvictorAdvancedConfig,
    updateAdvancedConfig: evictorApi.evictorAPIUpdateEvictorAdvancedConfig,
  };
};
